export default "__VITE_ASSET__BLfN4suG__"